// 格式化视频时长
const formatSeconds = (value) => {
    let h = Math.floor(value / 3600) < 10 ? '0' + Math.floor(value / 3600) : Math.floor(value / 3600)
    let m = Math.floor((value / 60 % 60)) < 10 ? '0' + Math.floor((value / 60 % 60)) : Math.floor((value / 60 % 60))
    let s = Math.floor((value % 60)) < 10 ? '0' + Math.floor((value % 60)) : Math.floor((value % 60))
    let res = ''
    if (h !== "00") {
        res += h + '时' + m + '分' + s + '秒'
    } else if (m !== '00') {
        res += m + '分' + s + '秒'
    } else {
        res += s + '秒'
    }
    return res;
}

export default formatSeconds;



// WEBPACK FOOTER //
// ./src/utils/formatSecond.js